module.exports = __webpack_public_path__ + "static/media/checkbook.3bf8aff9.svg";